export default {
  back: '返回',
}
